export default "__VITE_ASSET__d5de4a30__"